import {
  Dialog,
  Card,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { EmailOutlined, PhoneOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { BaseDialogProps } from './types';

export type BaseContactDialogProps = BaseDialogProps;

export function BaseContactDialog({
  open,
  onClose,
  maxWidth = 'sm',
  DialogProps: additionalDialogProps,
}: BaseContactDialogProps) {
  const { t } = useTranslation('common');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      {...additionalDialogProps}
      PaperProps={{
        sx: { 
          backgroundColor: 'transparent',
          boxShadow: 'none',
          ...additionalDialogProps?.PaperProps?.sx 
        }
      }}
    >
      <Card 
        sx={{ 
          backgroundColor: '#f5f5f5',
          maxWidth: '525px',
          maxHeight: '350px',
        }}
      >
        <List disablePadding>
          <ListItemButton
            component="a"
            href="mailto:ai-support@certara.com"
          >
            <ListItemIcon>
              <EmailOutlined />
            </ListItemIcon>
            <ListItemText 
              primary={t('contactDialog.emailSupport')}
            />
          </ListItemButton>
          
          <ListItemButton
            component="a"
            href="tel:+19198524620"
          >
            <ListItemIcon>
              <PhoneOutlined />
            </ListItemIcon>
            <ListItemText 
              primary={t('contactDialog.callSupport')}
            />
          </ListItemButton>
        </List>
      </Card>
    </Dialog>
  );
}
